import React, { useState, useEffect } from "react";
import { MainAdminNewsCategoryTable } from "../../components"
import {Outlet} from "react-router-dom"
import Group from "../../assets/icon/NewsIcons/MainAdmin/NewsGroup"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
const MainAdminTagsCategory = () => {

    const [showDeleteModal,setShowDeleteModal] = React.useState(false);
 const [reCheck, setRecheck] = useState(false);
    const [data, setData] = useState();
    const [cats, setCats] = useState();
    const [search, setSearch] = useState("");
    const [edit, setEdit] = useState(false);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
      let navigate = useNavigate();

 const [allValues, setAllValues] = useState({
    Tag:cats?cats?.tag: '',
    Edit:false

  });
       const GetData = async () => {
            const writersData = await axiosReq("Admins/GetTags?page=" + page + "&&pageSize=" + row + "&&search=" + search, "get");
            console.log("slm")
            console.log(writersData)
            console.log("slm")
            setData(writersData?.data)
            setCount(writersData?.count)
        }
        const auth = async () => {
                const cookies = new Cookies();
                var token = cookies.get('token');
                console.log(token)
                console.log(cookies.get('role'))
                if (!token) {
                    navigate("/admin");
                } else {
                    if( cookies.get('role')=="Admin")
                   {
        
                       GetData()
                   }
        
                    
                    else {
                        navigate("/admin");
        
                    }
                }
            }
        useEffect(() => {
    
            auth();
        }, [reCheck,search,page, row,]);
    return(
        <div>
            <div className="flex justify-between items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Group color={'#184548'}/></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">دسته بندی برچسب ها</p>
                </div>
                <div className="flex items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e)=>setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search/></button>
                    </div>
                    <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-search-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report/></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px] w-full flex">
                <div className="w-[29%] ml-[1%]"><Outlet context={[setRecheck,reCheck,cats,allValues,setAllValues,edit]}/></div>
                <div className="w-[70%]"><MainAdminNewsCategoryTable
                 data={data} 
                 tags={true}
                 reCheck={reCheck} 
                 setRecheck={setRecheck}
                 setAllValues={setAllValues}
                 setEdit={setEdit}
                 count={count} page={page} setPage={setPage} row={row} setRow={setRow}/></div>
            </div>
        </div>
    )
}

export default MainAdminTagsCategory;